// src/utils/api.js
import axios from "axios";
import store from "@/store";

const API_ROOT = process.env.VUE_APP_API_ROOT;

// GET. `config` is merged in for the cases a plain JSON GET cannot cover --
// `responseType: "blob"` for a file download, which needs the bearer token and
// so cannot be a plain link.
export async function apiGet(url, params = {}, config = {}) {
  const access = store.getters.access;

  return axios.get(`${API_ROOT}${url}`, {
    params,
    headers: {
      Authorization: `Bearer ${access}`,
    },
    ...config,
  });
}

// POST
export async function apiPost(url, data = {}) {
  const access = store.getters.access;

  return axios.post(`${API_ROOT}${url}`, data, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });
}

// PUT
export async function apiPut(url, data = {}) {
  const access = store.getters.access;

  return axios.put(`${API_ROOT}${url}`, data, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });
}

// PATCH
export async function apiPatch(url, data = {}) {
  const access = store.getters.access;

  return axios.patch(`${API_ROOT}${url}`, data, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });
}

// DELETE
export async function apiDelete(url) {
  const access = store.getters.access;

  return axios.delete(`${API_ROOT}${url}`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });
}
